// import React, { useState, useEffect } from 'react'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom/dist';
import AddPaymentGateWays from '../../core/modals/inventory/addpaymentgateways';
import Swal from 'sweetalert2';
import Table from '../../core/pagination/datatable'
import { PlusCircle  } from 'feather-icons-react/build/IconComponents';
import withReactContent from 'sweetalert2-react-content';
import {set_gateway_list, set_gateway_edit, set_page_refresh} from "../../core/redux/action";
import axios from 'axios';
// import { APIgetStores } from "../../api/settings.ts";


const PaymentGateWays = () => {
    const dispatch = useDispatch();
    const pageRefresh = useSelector((state) => (state.pageRefresh?.paymentConfigs || 0));
    // const [dataStore, setDataStore] = useState([]);
    const l = useSelector((state) => state.language || "en");
    const t = useSelector((state) => state.translation || "en");
    // const [isFetching, setIsFetching] = useState(false);

    useEffect(() => {
        async function fetchData() {
          let result = await axios.get("getstorepaymentconfig/");
          dispatch(set_gateway_list(result.data.paymentConfigs))
        }
        //  if (!isFetching) {
        //     getStoreApi();
        //   }

        fetchData()
        
      }, [pageRefresh])
      
      
    const dataSource = useSelector((state) => state.gateway_list);
    const permissions = useSelector(state => state.permissions) || [];
    const roleTitle = useSelector(state => state.roleTitle) || '';
    const roleTitleAdmin = useSelector(state => state.roleTitleAdmin) || '';

    const canView = roleTitle === roleTitleAdmin || permissions.some(p => p.Module.toLowerCase() === 'brands' && p.Permission.toLowerCase() === 'view');
    const canCreate = roleTitle === roleTitleAdmin || permissions.some(p => p.Module.toLowerCase() === 'brands' && p.Permission.toLowerCase() === 'create');
    const canUpdate = roleTitle === roleTitleAdmin || permissions.some(p => p.Module.toLowerCase() === 'brands' && p.Permission.toLowerCase() === 'update');
    const canDelete = roleTitle === roleTitleAdmin || permissions.some(p => p.Module.toLowerCase() === 'brands' && p.Permission.toLowerCase() === 'delete');

    if (!canView) {
        return ( 
        <div className={`${l === 'ar' ? 'page-wrapper-rtl' : 'page-wrapper'}`}><div className="content"><p>{t?.[l]?.["no_permission"] || "You do not have permission to view this page."}</p></div></div>
    )}

    const columns = [
        {
            title: t?.[l]?.["country"] || "Country",
            dataIndex: "country",
            key: "country",
        },
        {
            title: t?.[l]?.["store_name"] || "Store Name",
            dataIndex: "stores",
            render: (stores) => stores?.map(store => store.storeName).join(", "),
        },

        {
            title: t?.[l]?.["payment_type"] || "Payment Type",
            dataIndex: "paymentDetails",
            render: (paymentDetails) => {
                if (!Array.isArray(paymentDetails)) {
                    return t?.[l]?.["no_payment_details"] || "No Payment Details";
                }
                return paymentDetails
                    .map(payment => t?.[l]?.[payment.paymentType] || payment.paymentType)
                    .join(", ");
            },
            // render: (paymentDetails) => 
            //     paymentDetails?.map(payment => t?.[l]?.[payment.paymentType] || payment.paymentType).join(", "),
        },

        {
            title: t?.[l]?.["action"] || 'Actions',
            dataIndex: 'actions',
            key: 'actions',
            render: (text, record) => (
                <td className="action-table-data">
                    <div className="edit-delete-action">
                    {canUpdate && (
                        <Link className="me-2 p-2" to="#" data-bs-toggle="modal" data-bs-target="#add-brand" onClick={() => {editBrand(record)}}>
                            <i data-feather="edit" className="feather-edit"></i>
                        </Link>
                        )}
                            {canDelete && (
                //        <Link className="me-2 p-2" to="#"   onClick={() => showConfirmationAlert(record)}>
                //        <i data-feather="trash-2" className="feather-trash-2"></i>
                //    </Link>
                <Link className="me-2 p-2" to="#"
                onClick={(e) => {
                 e.preventDefault(); // Prevent the default anchor behavior
                 showConfirmationAlert(record);
               }}>
                <i data-feather="trash-2" className="feather-trash-2"></i>
            </Link>
                   
                        )}
               
               
                    </div>
                </td>
            )
        },
    ]
    const MySwal = withReactContent(Swal);

    const editBrand = async (record) => {
        dispatch(set_gateway_edit(record))
    }
    const showConfirmationAlert = (record) => {
        MySwal.fire({
            title: t?.[l]?.["are_you_sure?"] || "Are you sure?",
            text: t?.[l]?.["you_won't_be_able_to_revert_this!"] || "You won't be able to revert this!",
            showCancelButton: true,
            confirmButtonColor: "#00ff00",
            confirmButtonText: t?.[l]?.["yes,_delete_it!"] || "Yes, delete it!",
            cancelButtonColor: "#ff0000",
            cancelButtonText: t?.[l]?.["cancel"] || "Cancel",
        }).then(async (result) => {
            if (result.isConfirmed) {
              try {
                console.log('record._id',record);
                let result = await axios.post("removestorepaymentconfig/", {_id: record._id});
                console.log(result)
                dispatch(set_page_refresh("paymentConfigs"))
                MySwal.fire({
                title: t?.[l]?.["deleted!"] || "Deleted!",
                text: t?.[l]?.["item_has_been_deleted."] || "Item has been deleted.",
                className: "btn btn-success",
                confirmButtonText: t?.[l]?.["ok"] || "OK",
                  customClass: {
                    confirmButton: "btn btn-success",
                  },
                }).then(() => {
                });
              } catch(e) {
                console.log(e)
                return false;
              }
              
            } else {
              MySwal.close();
            }
        });
    };
    return (
        <div>
            <div className={`${l === 'ar' ? 'page-wrapper-rtl' : 'page-wrapper'}`}>
                <div className="content">
                    <div className="page-header">
                        <div className="add-item d-flex">
                            <div className="page-title">
                                <h4>{t?.[l]?.["payment_gateways"] || "Payment Gateways"}</h4>
                                <h6>{t?.[l]?.["manage_payment_gateways"] || "Manage Payment Gateways"}</h6>
                            </div>
                        </div>
              
                        {canCreate ? (
                        <div className="page-btn">
                            <Link
                                to="#"
                                className="btn btn-added"
                                data-bs-toggle="modal"
                                data-bs-target="#add-brand"
                                onClick={() => dispatch(set_gateway_edit({}))}
                            >
                                <PlusCircle className="me-2" />
                                {t?.[l]?.["add_payment_gateways"] || "Add Payment Gateways"}
                            </Link>
                        </div>
                          ) : null}
                    </div>
                    {/* /product list */}
                    <div className="card table-list-card">
                        <div className="card-body">
                            <div className="table-responsive">
                                <Table columns={columns} dataSource={dataSource} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <AddPaymentGateWays />
        </div>
    )
}

export default PaymentGateWays;
